import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

const HistoricalRiesgoInherenteChart = ({ historicoinherente, getColor }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current || !historicoinherente || historicoinherente.length === 0) return;

    if (!chartInstanceRef.current) {
      chartInstanceRef.current = echarts.init(chartRef.current);
    }

    const chart = chartInstanceRef.current;

    const seriesData = historicoinherente.map((item, index) => ({
      name: `Riesgo ID: ${item.idriesgo}`,
      type: "line",
      data: item.exposicioninherentep95,
      lineStyle: { color: getColor(index) },
      itemStyle: { color: getColor(index) },
    }));

    const dates = historicoinherente[0].fechamodificacion.map((dateStr) =>
      new Date(dateStr).toLocaleDateString()
    );

    const option = {
      title: { text: "Histórico Riesgo Inherente", left: "center" },
      tooltip: { trigger: "axis" },
      legend: { data: seriesData.map((serie) => serie.name), top: 30 },
      grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
      xAxis: { type: "category", boundaryGap: false, data: dates },
      yAxis: { type: "value" },
      series: seriesData,
    };

    chart.setOption(option);

    return () => {
      chart.dispose();
      chartInstanceRef.current = null;
    };
  }, [historicoinherente, getColor]);

  return <div ref={chartRef} style={{ width: "100%", height: "500px" }} />;
};

export default HistoricalRiesgoInherenteChart;
